"use strict";
exports.__esModule = true;
exports.isGeoPushpinChartLatitudeLongitudeProps = exports.isGeoPushpinChartProps = void 0;
/**
 * @internal
 */
function isGeoPushpinChartProps(props) {
    return props.location !== undefined;
}
exports.isGeoPushpinChartProps = isGeoPushpinChartProps;
/**
 * @internal
 */
function isGeoPushpinChartLatitudeLongitudeProps(props) {
    var latitudeLongitudeProps = props;
    return latitudeLongitudeProps.latitude !== undefined && latitudeLongitudeProps.longitude !== undefined;
}
exports.isGeoPushpinChartLatitudeLongitudeProps = isGeoPushpinChartLatitudeLongitudeProps;
//# sourceMappingURL=GeoChart.js.map